import styled, { keyframes } from 'styled-components';  
  
const zoomInOut = keyframes`  
  0% {  
    transform: scale(1);  
  }  
  50% {  
    transform: scale(1.2);  
  }  
  100% {  
    transform: scale(1);  
  }  
`;  
  
const LoadingContainer = styled.div`  
  display: flex;  
  flex-direction: column;  
  justify-content: center;  
  align-items: center;  
  height: 100vh;  
  // background: linear-gradient(to right, #006331, #B2D7C5);  
`;  
  
const LoadingText = styled.div`  
  font-size: 2rem;  
  color: #FFFFFF;  
  font-weight: bold;  
  margin-bottom: 20px;  
`;  
  
const LoadingImage = styled.img`  
  width: 100px;  
  height: 100px;  
  animation: ${zoomInOut} 2s infinite;  
  border-radius: 10px;  /* ここを追加 */  
`;  
  
function Loading() {  
  return (  
    <LoadingContainer>  
      <LoadingText>Loading...</LoadingText>  
      <LoadingImage src="/robo_on.jpg" alt="Loading" />  
      <a href="/robots" style={{ display: 'block', margin: '10px 0', color: 'white', fontWeight: 'bold', textDecoration: 'none' }}>TOP画面に戻る</a>  
    </LoadingContainer>  
  );  
}  
  
export default Loading;  
